<div [class]="chartDownloaderClass"></div>
